'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorPieChartOutlined = function EditorPieChartOutlined(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z' })
  );
};
EditorPieChartOutlined = (0, _pure2.default)(EditorPieChartOutlined);
EditorPieChartOutlined.displayName = 'EditorPieChartOutlined';
EditorPieChartOutlined.muiName = 'SvgIcon';

exports.default = EditorPieChartOutlined;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/pie-chart-outlined.js
// module id = 1411
// module chunks = 0